<template>
  <ul class="list" :class="{
    'list--full-width': blok.full_width,
  }">
    <StoryblokComponent v-for="childBlok in blok.items" :key="childBlok._uid" v-editable="blok" :blok="childBlok"
      class="list__item" :class="[blok.bullet_point_image ? 'list__item--custom-image' : blok.bullet_point, blok.style]"
      :space="blok.space_between" :font="blok.font" :image="blok.bullet_point_image" />
  </ul>
</template>

<script lang="ts" setup>
import type { SbTextListStoryblok } from '@/types'

interface Props {
  blok: SbTextListStoryblok
}
defineProps<Props>()
</script>
<style lang="scss" scoped>
.list {
  &--full-width {
    width: 100%;
  }

  &__item {
    &:last-child {
      margin-bottom: 4px;
    }

    &--black-point,
    &--blue-point,
    &--cobalt-point,
    &--red-point {
      list-style: disc;
      list-style-position: outside;
      margin-left: 20px;
      padding: 0;
    }

    &--blue-point::marker {
      color: var(--blue-600);
    }

    &--cobalt-point::marker {
      color: var(--cobalt-600);
    }

    &--red-point::marker {
      color: var(--red-500);
    }

    &--building {
      &::before {
        @include icon('@/assets/icons/building.svg', 16px, 16px);

        top: 7px;
      }
    }

    &--custom-image {
      &::before {
        background-image: var(--bullet-img-url);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 20px;
        height: 20px;
        top: 2px;
      }
    }

    &--checkmark {
      padding-left: 44px;

      &:not(:last-child) {
        margin-bottom: 16px !important;

        @media (min-width: $breakpoint-md) {
          margin-bottom: 20px !important;
        }
      }

      &::before {
        top: 0;
        left: 0;

        @include icon('@/assets/icons/circle-checkmark-violet.svg', 32px, 32px);
      }
    }

    &--blue-background {
      background-color: #f2f8ff;
      padding: 9px 38px;
      border-radius: 8px;

      &.list__item--checkmark {
        &:not(:last-child) {
          margin-bottom: 6px !important;
        }

        &::before {
          top: calc((100% - 20px) / 2);
          left: 10px;

          @include icon('@/assets/icons/circle-checkmark.svg', 20px, 20px);
        }
      }
    }
  }
}
</style>
